import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent {
  form: UntypedFormGroup;
  submitted = false;
  loading = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
  ) {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  requestResetLink(): void {
    this.submitted = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    const email = this.form.controls.email.value.trim();

    this.authService.requestPasswordReset(email).subscribe({
      next: () => {
        this.loading = false;
        this.successMessage =
          'If an active account exists for this email address, a password reset link has been sent.';
        this.toastService.success(
          'Reset link requested',
          'If an active account exists for this email address, a reset link will be sent shortly.',
        );
      },
      error: (error) => {
        console.error('Could not request password reset:', error);
        this.loading = false;
        this.errorMessage = 'Could not request a reset link. Please try again later.';
        this.toastService.error('Password reset failed', this.errorMessage);
      },
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
